// MODULES
import React from "react";

import {createClassName} from "@helpers/utils";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import EditableField from "../../../components/EditableField/EditableField";
import OptionsList from "../../../components/OptionsList/OptionsList";
import fulfillmentCheck from "./Autogiro.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import AbstractAutogiro from "../AbstractAutogiro";
import Select from "../../../../../components/Select/Select";
import Validator from "../../../../../classes/Validator";


export default class Autogiro extends AbstractAutogiro {

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {state, props} = this;
		const {availableBanks} = props;
		const {fields, validFields} = state;

		const classes = createClassName("Cob-Autogiro-Alfakraft", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const textClasses = createClassName("description", {
			"contractable": true,
			"expanded": state.textFieldExpanded
		});

		/**
		 * Set up the dropdown with selectable banks.
		 */
		let availableBankOptions = [];
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;
			availableBankOptions.push({
				label: bankName,
				value: bankName
			});
		}

		availableBankOptions.push({
			label: "Övriga",
			value: "-"
		});

		let selectedBankIndex = -1;

		if (state.fields.customer_account_bank && state.fields.customer_account_bank.length > 0) {
			let bankFoundInList = false;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) {
					continue;
				}
				selectedBankIndex++;
				if (bankName === state.fields.customer_account_bank) {
					bankFoundInList = true;
					break;
				}
			}

			if (!bankFoundInList && state.fields.customer_account_bank === '-') {
				selectedBankIndex++;
			}
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<h2>Autogiro</h2>

				<p style={{
					margin: "0 0 10px 0",
					maxWidth: "620px",
					fontSize: "14px"
				}}>
					För att du ska kunna sätta in och ta ut pengar, samt månadsspara i UCITS-fonder via autogiro måste
					nedanstående autogiromedgivande fyllas i.
				</p>

				<h3>Autogiromedgivande</h3>

				<div className={textClasses}>
					<p>
						Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto eller
						av betalaren senare angivet Konto, på begäran av angiven betalningsmottagare för betalning till
						denne på viss dag (”förfallodagen”) via Autogiro. Betalaren medger att insättning och uttag från
						angivet konto eller av betalaren föranmält konto får göras på begäran av betalaren. Betalaren
						samtycker till att behandling av personuppgifter som lämnats i detta medgivande behandlas av
						betalarens betaltjänstleverantör, betalningsmottagaren, betalningsmottagarens
						betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten.
						Personuppgiftsansvariga för denna personuppgiftsbehandling är betalarens betaltjänstleverantör,
						betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör. Betalaren kan när som
						helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta
						betalarens betaltjänstleverantör. Ytterligare information om behandling av personuppgifter i
						samband med betalningar kan finnas i villkoren för kontot och i avtalet med
						betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att
						tjänsten i sin helhet avslutas.
					</p>
					<div className="expand">
						<div className="first"></div>
						<div className="second"></div>
						<div className="third" onClick={this._onExpandText}>Expandera texten</div>
					</div>
					<div className="contract" onClick={this._onExpandText}>
						Minimera texten
					</div>
				</div>

				<FieldsCollection
					fields={[
						{
							render: (
								<OptionsList
									type="radio"
									orientation="horizontal"
									name="customer_autogiro"
									description="Jag ger mitt medgivande till betalning via autogiro"
									options={state.fields.customer_autogiro.options}
									onChange={this._onChangeAutogiroSelect}
								/>
							)
						}
					]}
				/>

				{!!state.fields.customer_autogiro.options[0].checked && (
					<React.Fragment>
						<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
							<Select
								name="customer_account_bank"
								label="Bank"
								style={{width: "45%", marginRight: "10px"}}
								selectedIndex={selectedBankIndex}
								options={availableBankOptions}
								onChange={this._onSelectBankChange}
							/>

							{fields.customer_account_bank === '-' && (
								<React.Fragment>
									<EditableField
										name="customer_account_bank_custom"
										label="Bankens namn"
										style={{width: "45%"}}
										value={fields.customer_account_bank_custom || ""}
										valid={validFields.customer_account_bank_custom}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
									/>
									<input type="hidden" name="customer_account_bank"
										   value={fields.customer_account_bank_custom}/>
								</React.Fragment>
							)}

							{fields.customer_account_bank !== '-' && (
								<input type="hidden" name="customer_account_bank_custom" value=""/>
							)}
						</div>

						{fields.customer_account_bank === 'Swedbank' && (
							<p style={{background: "#FFFFD5", padding: "10px", fontSize: "12px", margin: "10px 0", maxWidth: "600px"}}>
								Det förekommer att Swedbank har en femte siffra i clearingnumret. Vänligen ange
								enbart de fyra första innan bindestrecket. Exempel: 8214-9 ska anges som 8214.
							</p>
						)}

						<div style={{width: "100%", flexDirection: "row", margin: "5px 0"}}>
							<EditableField
								name="customer_account_bank_clearingno"
								style={{width: "45%", marginRight: "10px"}}
								label="Clearingnummer"
								value={fields.customer_account_bank_clearingno || ""}
								valid={validFields.customer_account_bank_clearingno}
								onChange={this._onClearingFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<EditableField
								name="customer_account_bank_no"
								style={{width: "45%"}}
								label="Kontonummer"
								value={fields.customer_account_bank_no || ""}
								valid={validFields.customer_account_bank_no}
								onChange={this._onAccountFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<input type="hidden" name="customer_account_clearing_no" value={fields.customer_account_bank_clearingno || ""} />
						</div>

						<p>
							Utelämna eventuella punkter och streck i kontonumret.
						</p>
					</React.Fragment>
				)}
			</div>
		);
	}

	_onExpandText = () => {
		this.setState({
			textFieldExpanded: !this.state.textFieldExpanded
		});
	};

	_onClearingFieldChange = (name, value) => {
		// Remove all non-numbers
		value = value.replace(/[^0-9]+/g, "");

		// Limit clearing numbers to 4 numbers, we'll show a message that says to enter only first four for the
		// banks with longer numbers
		if (value.length >= 4) {
			value = value.substring(0, 4);
		}

		let valid = (this.state.fields.customer_account_bank === '-') ?
			true :
			Validator.validateClearingNumber(value, this.state.fields.customer_account_bank, this.props.availableBanks);

		CobHelpers.onViewFieldChange.call(this, name, value, valid);
	};

	_onAccountFieldChange = (name, value) => {
		// Remove dashes
		value = value.replace("-", "");
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldChange = (name, value) => {
		/**
		 * For the single deposit and monthly savings field treat zero as if the value has not been entered
		 */
		if ((name === 'customer_autogiro_single_amount' || name === 'customer_autogiro_monthly_amount') && value === "0") {
			value = "";
		}

		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};

	_onFieldBlur = (name) => {
		if (name === 'customer_account_bank_clearingno') {
			CobHelpers.onViewFieldBlur.call(this, name, null, true);
		}
		else {
			CobHelpers.onViewFieldBlur.call(this, name);
		}
	};

	_fieldValidator = (name, value) => {
		if (name === 'customer_account_bank_no') {
			return this._isValidBankAccountNo(false, value, this.state.fields.customer_autogiro_bank_clearingno);
		}

		return value.length > 0;
	};


	_onSelectBankChange = (option) => {
		CobHelpers.onViewFieldChange.call(this, "customer_account_bank", option.value);
	};

	_onChangeAutogiroSelect = ({type, name}, option, index) => {
		name = name || option.name;
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));

		this.props.actions.setAppState({
			isAutogiroApproved: option.value === 'yes'
		});
	};
}

// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"customer_account_bank",
		"customer_account_bank_custom",
		"customer_account_bank_no",
		"customer_account_bank_clearingno",
		"customer_autogiro"
	];
}

function _createProductClassOptions() {
	return [
		{label: "Ja", value: "yes"},
		{label: "Nej", value: "no"}
	];
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	return {
		textFieldExpanded: false,
		products: [],

		fields: {
			"customer_account_bank": "",
			"customer_account_bank_custom": "",
			"customer_account_bank_no": "",
			"customer_account_bank_clearingno": "",
			"customer_autogiro": {options: _createProductClassOptions()},
		},
		validFields: {}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/alfakraft/Autogiro.js